const React = require("react");
const { SiteProvider } = require("./src/contexts/site-state");

exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) {
    return location.hash;
  }
  window.scrollTo(0, 0);
  return false;
};

exports.wrapRootElement = ({ element }) =>
  React.createElement(SiteProvider, null, element);